import trans from '../trans';

export function translate(key, replace = {}) {
  if(! key) {
    return "";
  }

  return trans(key, replace);
}
